import parsePhoneNumberFromString from 'libphonenumber-js';
import slugify from 'slugify';

export const GST_PERCENT = 0.1;

export function getTotalAmount(amount: number | number[], includeGst: boolean) {
    const taxMultiplier = includeGst ? (1 + GST_PERCENT) : 1;

    // When summing items up (ie. combined addons),
    // we need to apply tax calcs at a line item level to match invoice pricing
    if (Array.isArray(amount)) {
        return amount.reduce(
            (acc, curr) => acc + Math.round((curr * taxMultiplier) * 100) / 100,
            0
        );
    }

    return amount * taxMultiplier;
}

export function formatMoney(amount: number | number[], includeGst: boolean) {
    return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(
        getTotalAmount(amount, includeGst)
    );
}

export const formatPrice = (amount: number, trailingDigits = 2) => {
    if (Number.isNaN(amount)) {
        return null;
    }

    return amount.toLocaleString('en-AU', {
        currency: 'AUD',
        minimumFractionDigits: trailingDigits,
    });
};

export const formatContactNumber = (number: string | null) => {
    if (number === null) return null;

    const phoneNumber = parsePhoneNumberFromString(number, {
        defaultCountry: 'AU',
        extract: false,
    });

    if (phoneNumber !== undefined && phoneNumber.country === 'AU') {
        return phoneNumber.formatNational();
    }

    return number;
};

// https://www.npmjs.com/package/slugify
export const slugifyString = (
    s: string | null,
    options?: {
        replacement?: string; // replace spaces with replacement character
        remove?: RegExp; // remove characters that match regex
        lower?: boolean; // convert to lower case
        strict?: boolean; // strip special characters except replacement
        locale?: string; // language code of the locale to use
        trim?: boolean; // trim leading and trailing replacement chars
    }
) => {
    if (typeof s !== 'string') {
        return s;
    }

    return slugify(s, {
        lower: true,
        replacement: '-',
        strict: true,
        locale: 'en',
        trim: true,
        ...options,
    });
};

export const parseUNSAFEOriginalComplianceUserId = (
    UNSAFE_originalComplianceUserId: string | null | undefined
) => {
    if (UNSAFE_originalComplianceUserId === null || UNSAFE_originalComplianceUserId === undefined) {
        return null;
    }

    if (typeof UNSAFE_originalComplianceUserId === 'number') {
        return UNSAFE_originalComplianceUserId;
    }

    const userId = parseInt(UNSAFE_originalComplianceUserId, 10);

    if (Number.isNaN(userId)) {
        return null;
    }

    return userId;
};
